function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.reverse.js";
import "core-js/modules/es.array.find-index.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.string.search.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.from.js";
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useCallback, useEffect, useState, useMemo } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { Tabs } from "../Tabs";
var NAVBAR_HEIGHT = 72;
export function NavigationTabs(_ref) {
  var sections = _ref.sections,
    onChangeTab = _ref.onChangeTab,
    _ref$topOffset = _ref.topOffset,
    topOffset = _ref$topOffset === void 0 ? NAVBAR_HEIGHT : _ref$topOffset;
  var history = useHistory();
  var location = useLocation();
  var _useState = useState(0),
    _useState2 = _slicedToArray(_useState, 2),
    activeIndex = _useState2[0],
    setActiveIndex = _useState2[1];
  var offsets = useMemo(function () {
    return sections.map(function (s) {
      var _s$ref$current$offset, _s$ref$current;
      return (_s$ref$current$offset = (_s$ref$current = s.ref.current) === null || _s$ref$current === void 0 ? void 0 : _s$ref$current.offsetTop) !== null && _s$ref$current$offset !== void 0 ? _s$ref$current$offset : 0;
    });
  }, [sections.map(function (s) {
    var _s$ref$current$offset2, _s$ref$current2;
    return (_s$ref$current$offset2 = (_s$ref$current2 = s.ref.current) === null || _s$ref$current2 === void 0 ? void 0 : _s$ref$current2.offsetTop) !== null && _s$ref$current$offset2 !== void 0 ? _s$ref$current$offset2 : 0;
  }).join(',')]);
  var getSectionByIndex = function getSectionByIndex(index) {
    return sections[index];
  };
  var getSectionRefByIndex = function getSectionRefByIndex(index) {
    var _getSectionByIndex;
    return (_getSectionByIndex = getSectionByIndex(index)) === null || _getSectionByIndex === void 0 ? void 0 : _getSectionByIndex.ref;
  };
  var scrollTo = function scrollTo(ref) {
    if (!(ref !== null && ref !== void 0 && ref.current)) {
      return;
    }
    window.scrollTo({
      behavior: 'smooth',
      top: ref.current.offsetTop - topOffset
    });
  };
  var handleOnChangeTab = useCallback(function (i) {
    setActiveIndex(i);
    var ref = getSectionRefByIndex(i);
    scrollTo(ref);
    onChangeTab && onChangeTab(getSectionByIndex(i));
  }, [onChangeTab, setActiveIndex]);
  var getScrollOffsetIndex = useCallback(function (scrollPosition) {
    var topPosition = scrollPosition + topOffset;

    // we start searching from the end
    var selectedOffset = _toConsumableArray(offsets).reverse().find(function (offset) {
      return topPosition >= offset;
    });
    return offsets.findIndex(function (s) {
      return s === selectedOffset;
    });
  }, [offsets]);
  useEffect(function () {
    var onScroll = function onScroll() {
      var index = getScrollOffsetIndex(window.scrollY);
      var ref = getSectionRefByIndex(index);
      if (ref) {
        var hash = "#".concat(sections[index].hash);
        if (hash === location.hash) {
          return;
        }
        history.replace({
          hash: hash,
          search: location.search
        });
        setActiveIndex(index);
      } else {
        history.replace(location.pathname + location.search);
        setActiveIndex(0);
      }
    };
    window.addEventListener('scroll', onScroll);
    return function () {
      return window.removeEventListener('scroll', onScroll);
    };
  }, [offsets, location.hash, getScrollOffsetIndex]);
  useEffect(function () {
    // Scroll to the section specified in the query parameter (if valid)
    var sectionName = location.hash.slice(1);
    var ref = getSectionRefByIndex(sections.findIndex(function (s) {
      return s.hash === sectionName;
    }));
    scrollTo(ref);
  }, []);
  return /*#__PURE__*/React.createElement(Tabs, {
    currentTab: activeIndex,
    items: sections.map(function (s) {
      return {
        id: s.hash,
        title: s.title
      };
    }),
    onChangeTab: handleOnChangeTab
  });
}